import {
  createResource,
  updateAuthHeader
} from './helper'

import {
  plugin
} from './plugin'

import {
  admin,
  device,
  devices,
  exports,
  firmwareDelete,
  firmwareList,
  firmwareUpload,
  image,
  infoModel,
  legal,
  notifications,
  onlineTesting,
  reset,
  serviceConfig,
  session,
  theme,
  tsdb,
  total,
  user,
  users
} from './resources'

export {
  admin,
  createResource,
  device,
  devices,
  exports,
  firmwareDelete,
  firmwareList,
  firmwareUpload,
  image,
  infoModel,
  legal,
  notifications,
  onlineTesting,
  plugin,
  reset,
  serviceConfig,
  session,
  theme,
  tsdb,
  total,
  updateAuthHeader,
  user,
  users
}



// WEBPACK FOOTER //
// ./src/api/index.js